import { apiClient } from "./apiClient";
import { API_BASE_URL } from "../../utils/constants";
import type {
  ContactRole,
  ContactRoleTarget,
  ProducerContactChains,
  ReorderItem,
} from "../../types/contact-role";

// The contact-roles endpoints live in the legacy `/api/` namespace next to
// the existing producer-contacts endpoints, so we hit the bare base URL
// (no `/v1/` prefix) for these calls.

const ROOT = API_BASE_URL.endsWith("/")
  ? API_BASE_URL.slice(0, -1)
  : API_BASE_URL;

export const contactRoleService = {
  async getChains(producerId: number): Promise<ProducerContactChains> {
    const r = await apiClient.get<ProducerContactChains>(
      `/producers/${producerId}/contact-chains/`,
    );
    return r.data;
  },

  async create(payload: {
    producer_contact: string;
    target: ContactRoleTarget;
    farm?: number | null;
    priority: number;
  }): Promise<ContactRole> {
    const r = await apiClient.post<ContactRole>(
      "/contact-roles/",
      payload,
    );
    return r.data;
  },

  async update(
    id: string,
    payload: Partial<{
      target: ContactRoleTarget;
      farm: number | null;
      priority: number;
    }>,
  ): Promise<ContactRole> {
    const r = await apiClient.patch<ContactRole>(
      `/contact-roles/${id}/`,
      payload,
    );
    return r.data;
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(`/contact-roles/${id}/`);
  },

  async bulkReorder(
    target: ContactRoleTarget,
    farmId: number | null,
    items: ReorderItem[],
  ): Promise<void> {
    await apiClient.post("/contact-roles/bulk-reorder/", {
      target,
      farm: farmId ?? null,
      items,
    });
  },

  // Frontend resolves `${ROOT}/contact-roles` directly when invoking from
  // legacy code paths (e.g. mock fetches). Exposed here for completeness.
  rootUrl: ROOT,
};

export default contactRoleService;
